module.exports = __webpack_public_path__ + "static/media/headsetparrot.c082ae63.gif";